module.exports = __webpack_public_path__ + "assets/img/tab1_03.7d45328d.jpg";